import { Center, Spinner } from '@chakra-ui/react';

export function CenteredSpinner() {
  return (
    <Center>
      <Spinner />
    </Center>
  );
}
